export default {
  bays(state) {
    return state.bays;
  }
};
